import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import ICONS from "../../../../../assets/Icons";
import StatusContainer from "../../../../../components/_utils/CommonStatus/StatusContainer";
import InfoCard from "../../../../../components/_utils/CommonStatus/StatusSubComponents/StatusCardContainer/InfoCard";
import TabsWeapperSection from "../../../../../components/_utils/CommonStatus/StatusSubComponents/TabsWrapperSection";
import { remitterAccountDetailsById } from "../../../../../redux/features/accounts/remitterAccount/remitterAccount";
import { setHideBreadCrumb } from "../../../../../redux/features/hideBreadCrumb/hideBreadCrumb";
import accountNameStandardised from "../../../../../utils/accountNamestandardised";

const RemitterAccountEditSuccess = (props) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const updatedName = location?.state?.updatedName;

  useEffect(() => {
    dispatch(setHideBreadCrumb({ hide: true }));

    return () => {
      dispatch(setHideBreadCrumb({ hide: false }));
    };
  }, [dispatch]);

  const consolidatedBankHandler = () => {
    navigate("/owner_account_dashboard/view_consolidated_statement");
  };

  const liveBankHandler = () => {
    navigate(`/owner_account_dashboard/itemized_activity_feed`);
  };

  const createAccountHandler = () => {
    navigate("/remitter_account_dashboard/create_remitter_account");
  };

  const viewDetailsHandler = () => {
    navigate(
      `/remitter_account_dashboard/remitter_account_view_all/remitter_account_detail_page/${id}`,
    );
  };

  const dashboardHandler = () => {
    navigate("/remitter_account_dashboard");
  };

  useEffect(() => {
    if (id) {
      dispatch(remitterAccountDetailsById({ id }));
    }
  }, [dispatch, id]);

  const primaryBtn = {
    enabledBgColor: "var(--text-primary)",
    enabledTextColor: "var(--positive-bg)",
    iconToBeAlign: "left",
    fullWidthRequired: true,
    imgColor: "var(--positive-bg)",
  };

  const outlineBtn = {
    enabledBgColor: "var(--bg-positive-bg)",
    enabledTextColor: "var(--text-primary)",
    iconToBeAlign: "left",
    fullWidthRequired: true,
    outLineColor: "var(--text-primary)",
    hoverOption: "dark",
  };

  const buttonRows = [
    [
      {
        ...primaryBtn,
        btnText: "Consolidated bank statement",
        icon: ICONS?.SELECTUSER,
        handleFunction: consolidatedBankHandler,
      },
      {
        ...primaryBtn,
        btnText: "Consolidated live statement",
        icon: ICONS?.SELECTUSER,
        handleFunction: liveBankHandler,
      },
      {
        ...primaryBtn,
        btnText: "Create account",
        icon: ICONS.SELECTUSER,
        handleFunction: createAccountHandler,
      },
      {
        ...primaryBtn,
        btnText: "View details",
        icon: ICONS.VIEW_DETAILS,
        handleFunction: viewDetailsHandler,
      },
      {
        ...outlineBtn,
        btnText: "Go to dashboard",
        icon: ICONS.DASHBOARD,
        handleFunction: dashboardHandler,
      },
    ],
  ];

  return (
    <div>
      <StatusContainer
        status="success"
        buttonRows={buttonRows}
        title="Account details updated successfully."
      >
        <TabsWeapperSection title="Account details">
          <>
            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: accountNameStandardised(updatedName),
                  leftSubTitle: "Account name",
                },
              ]}
            />
          </>
        </TabsWeapperSection>
      </StatusContainer>
    </div>
  );
};

export default RemitterAccountEditSuccess;
